export class AuthenticatedUser {
  username: string;
  authdata: string;

  constructor(username: string, authdata: string) {
    this.username = username;
    this.authdata = authdata;
  }
}
